import React from 'react';
// import { getLogo} from "../../commons/js/util";
import { useNomenclator } from '../../contexts/nomenclatorContext';
import styled from 'styled-components/macro';
import { fmt } from '../../utils/fmtUtils';
import Logo from '../../containers/Logo';
import { PartidoLogoNombreContainer } from './TablaVotosPartidos_FilaPartido';
import { useTranslate } from '../../contexts/languageContext';

const TablaTerritorios_CuerpoFilaTerritorio = ({data}) => {
  const nomenclator = useNomenclator();
  const par = nomenclator.partidos[Number(data.codpar) - 1];
  // const codpar = getLogo(par.codpar,'es','act');
  const nompar = (par===undefined)?'':par.nombre;
	const t = useTranslate();
  return (
    <tr>
      <td>{data.nombre}</td>
      <td>
				{
					data.pmesesc !== '0%' && data.hayEmpate !== '1' ? (
						<PartidoLogoNombreContainer>
							<StyledLogo codpar={par.codpar} height={'50px'} width={'50px'}/>
							<span style={{paddingLeft:'5px'}}>{nompar}</span>
						</PartidoLogoNombreContainer>
					) : data.pmesesc !== '0%' ?
					(
						<PartidoLogoNombreContainer>{t('empate')}</PartidoLogoNombreContainer>
					) :
					(
						<PartidoLogoNombreContainer>{t('sinInformacion')}</PartidoLogoNombreContainer>
					)
				}
			</td>
      <td>{fmt(data.mesesc)}</td>
      <td className="percent">{data.pmesesc}</td>
      <td>{fmt(data.votant)}</td>
      <td className="percent">{data.pvotant}</td>
    </tr>
  );
};

const StyledLogo = styled(Logo)`
  padding-top:5px;
  /* top: 5px; */
  /* height: 50px; */
  width: ${({ height }) => height};
`;

export default TablaTerritorios_CuerpoFilaTerritorio;
